import React, { useEffect } from 'react';
import { RouteComponentProps, Link } from '@reach/router';
import { RFC } from 'state/StateTypes';
import styled from 'styled-components';
import ViewContainer from 'components/ViewContainer';
import { useDispatch } from 'react-redux';
import { RESET_REQUESTED_PATHNAME } from 'state/PathnameReducer';

const NotFound: RFC<RouteComponentProps> = () => {
   const dispatch = useDispatch();
   useEffect(() => {
      dispatch({ type: RESET_REQUESTED_PATHNAME });
   }, []);
   return (
      <ViewContainer>
         <Header>
            We weren't able to find the page you're looking for
            <ReturnToLogin onClick={() => window.history.back()}>Return to previous page</ReturnToLogin>
         </Header>
      </ViewContainer>
   );
};

export default NotFound;

const Header = styled.header`
   color: ${({ theme }) => theme.primaryBlueDark};
   font-size: 1.3em;
   font-weight: 600;
   padding: 1.5em;
   margin: 0 auto;
   text-align: center;
`;

const ReturnToLogin = styled.a`
   margin: 1em auto;
   color: ${({ theme }) => theme.secondaryBlueLight};
   cursor: pointer;
   font-weight: 600;
   text-align: center;
   font-size: 0.9em;
   display: block;

   &:hover {
      color: ${({ theme }) => theme.secondaryBlueDark};
   }
`;
